import React from "react";
import { PaymentModel } from "../../types-interfaces/types";
import Button from "../button/Button";
import "../../css/modal/modalUpdatePayments.css";

interface ModalUpdatePaymentProps {
  payment: PaymentModel | undefined;
  action: string | undefined;
  handleConfirm: (paymentId: string, action: string) => void;
  handleCloseModal: () => void;
}

const ModalUpdatePayment: React.FC<ModalUpdatePaymentProps> = ({
  payment,
  action,
  handleConfirm,
  handleCloseModal
}) => {

  var status = "";
  if (action === "Anular") status = "anulado";
  if (action === "Devolver") status = "devuelto";
  if (action === "Desvincular") status = "desvinculado";

  return (
    <div className="update-payment-modal">
      <div className="title-div">
        <span className="title">{`¿Está seguro de que quiere cambiar estas operaciones al estado ${status}?`}</span>
      </div>
      <div className="table-div">
        <table className="update-payment-table">
          <thead className="update-payment-thead">
            <td className="update-payment-td-head">Rut Cliente</td>
            <td className="update-payment-td-head">Rut Pagador</td>
            <td className="update-payment-td-head">Monto</td>
            <td className="update-payment-td-head">Fecha de Pago</td>
          </thead>
          <tbody className="update-payment-tbody">
            <tr className="update-payment-tr">
              <td className="update-payment-td-body">{payment?.customerId}</td>
              <td className="update-payment-td-body">{payment?.payerId}</td>
              <td className="update-payment-td-body">{payment?.amount}</td>
              <td className="update-payment-td-body">{new Date(payment?.paymentCreationDate!).toLocaleDateString().replaceAll("-", "/")}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="confirm-btn-div">
        <Button className="confirm-btn" text={action} onClick={() => handleConfirm(payment?.id!, action!)} />
        <Button className="cancel-btn" text="Cancelar" onClick={() => handleCloseModal()} />
      </div>
    </div>
  );
};

export default ModalUpdatePayment;